var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('icon-cart',{attrs:{"width":_vm.width,"height":_vm.height,"rx":_vm.rx,"action":_vm.action,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }